export enum Favicon {
    VITA_CONCIERGE = '/favicon.ico',
    VITA_STUDENT_CONCIERGE = '/favicon2.ico',
    HOUSE_OF_SOCIAL = '/hos-favicon.ico',
}
